import { Loading } from '@/components';
import { useDevToolsStorage } from '@/features/dev-tools/_hooks/local-storage';
import { TableFundOwnerForLocalGovernment } from '@/features/mold/components/pdf';
import { getFundOwnerForLocalGovernmentData } from '@/features/mold/utils/fund-owner-for-local-government/get-pdf';
import { useLocalGovernmentFundIndividualReport } from '@/features/project/report/_hooks/report-individual';
import type { PaperSize } from '@/utils';
import type { FC } from 'react';

type Props = {
  projectId: string;
  fiscalYear: number;
  projectName: string;
  pageSize: PaperSize;
};

export const FundOwnerForLocalGovernmentReportPage: FC<Props> = ({
  projectId,
  fiscalYear,
  projectName,
  pageSize,
}) => {
  const localGovernmentFundIndividualReport =
    useLocalGovernmentFundIndividualReport(projectId);
  const { devtoolState } = useDevToolsStorage();
  const isDebugMode = !!devtoolState?.isDebugMode;

  const data = localGovernmentFundIndividualReport.data
    ? getFundOwnerForLocalGovernmentData({
        fiscalYear,
        data: localGovernmentFundIndividualReport.data,
        isDebugMode,
      })
    : null;

  return localGovernmentFundIndividualReport.isPending ? (
    <Loading />
  ) : (
    <>
      {data && (
        <TableFundOwnerForLocalGovernment
          fiscalYear={fiscalYear}
          projectName={projectName}
          header={data.header}
          rowData={data.data}
          footer={data.footer}
          paperSize={pageSize}
        />
      )}
    </>
  );
};
